import type {SVGProps} from 'react'
const SvgDarkLight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 512 512" {...props}>
    <path
      d="M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0s256 114.6 256 256M264 495.9c128.8-4.3 232-110 232-239.9S392.8 20.4 264 16.1z"
      style={{
        fill: '#333',
      }}
    />
  </svg>
)
export default SvgDarkLight
